import { render } from "./RolePermission.vue?vue&type=template&id=45c0437e&scoped=true"
import script from "./RolePermission.vue?vue&type=script&lang=js"
export * from "./RolePermission.vue?vue&type=script&lang=js"

import "./RolePermission.vue?vue&type=style&index=0&id=45c0437e&lang=scss&scoped=true"

import exportComponent from "../../../../../DIARC/pixonanimation.az/webadmin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45c0437e"]])

export default __exports__